import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset! Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-8">
      <div className="w-full max-w-sm" data-testid="reset-password-page">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-brand-ink/50 hover:text-brand-red transition-colors mb-10"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
        <h1 className="font-display text-4xl">Choose a new password</h1>
        {!token ? (
          <p className="mt-4 text-brand-ink/60" data-testid="reset-invalid-msg">This reset link is missing or invalid. Please request a new one from the sign-in page.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="reset-password-form">
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required placeholder="New password (min 8 chars)" className="w-full rounded-xl border border-brand-line px-4 py-3 focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="reset-new" />
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required placeholder="Confirm new password" className="w-full rounded-xl border border-brand-line px-4 py-3 focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="reset-confirm" />
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors disabled:opacity-60" data-testid="reset-submit-btn">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Reset password</button>
          </form>
        )}
      </div>
    </div>
  );
}
